<script>
import { eventGroupState } from "@app/store/eventGroupStore.svelte.js";
import { projectState } from "@app/store/projectStore.svelte.js";
import { insertHistoryAction } from "@app/store/historyStore.svelte.js";
import * as m from "@app/paraglide/messages.js";
import { canEditMetadata } from "@app/store/permissionStore.svelte.js";
/** @type {{eventIndex: any, disabled?: boolean}} */
let { event, disabled = false } = $props();

function removeSpeaker(speaker) {
    if (disabled) {
        return;
    }

    event.recipients = event.recipients.filter((sp) => {
        return sp.id !== speaker.id;
    });

    insertHistoryAction({
        name: "remove speaker", //action name
        eventGroup: projectState.selected,
        snapshots: [
            {
                store: "eventGroupState",
                value: JSON.stringify(eventGroupState),
            },
        ],
    });
}
</script>

{#if canEditMetadata("recipients")}
<div class="col-4 border-start border-end">
    <div class="speakerWrapper">
        {#each event.recipients || [] as speaker}
            <span
                class="badge m-1 text-custom-small {speaker.colour === 'yellow'
                    ? 'text-black'
                    : 'text-dark'}"
                style="background-color: {speaker.colour}">
                {#if !disabled}
                <a
                    href="#!/"
                    class="text-danger"
                    onclick={() => removeSpeaker(speaker)}
                    aria-label={m.event_recipients_remove_aria_label({name: speaker.name})}
                    ><i class="bi bi-x"></i></a>
                {/if}
                {speaker.name}</span>
        {:else}
            <span class="text-custom-small text-muted"
                >{m.event_recipients_no_recipients()}</span>
        {/each}
    </div>
</div>
{/if}

<style lang="css">
.speakerWrapper {
    overflow-x: auto;
    white-space: nowrap;
}
</style>
